# Карточка обращений на дашборде: ждущие ответа команды (OPEN и
# VIEWER_REPLIED, needsReply) и ждущие зрителя (WAITING_VIEWER), два алиаса.
query SupportRequestsDashboard($rowsPerPage: Int) {
  needsReply: supportRequests(
    rowsPerPage: $rowsPerPage
    filter: { needsReply: true }
  ) {
    count
    nodes {
      id
      type
      status
      createdAt
      user {
        id
        email
      }
    }
  }
  waitingViewer: supportRequests(
    rowsPerPage: $rowsPerPage
    filter: { status: WAITING_VIEWER }
  ) {
    count
    nodes {
      id
      type
      status
      createdAt
      user {
        id
        email
      }
    }
  }
}
